import { ANALYTICS_CAMPAIGNS_ID } from 'constants/index';
import { TAB_ANALYTICS } from 'constants/paths';
import { ANALYTICS_ACCOUNTS_DATA, ANALYTICS_CARD_DATA, ANALYTICS_INTENT_DATA, CONTACT_ANALYTICS, CONTENT_ANALYTICS } from 'constants/types';
import store from 'store';
import { getQueryAccountId } from 'utils';
import { getAccountsDashboard, getPaginatedAccountsData } from './Accounts/actions';
import { getContentEngagementList } from './Accounts/ContentEngagement/actions';
import { getDeliveredContactsList } from './Contacts/action';
import { getPaginatedContentData } from './Content/actions';
import { getAnalyticsCardData } from './Dashboard/actions';
import { getClickTrends, getEmailTrends } from './Insights/actions';
import { IAssetDropdownItem, ICampaignDropdownItem, IWorkflowDropdownItem } from './interfaces';

export const storeLoading = (type: any, payload?: any) => {
  store.dispatch({
    type,
    payload,
  });
};

export const serializeAnalyticsEmails = (assets: any[]) => {
  let newData: IAssetDropdownItem[] = [];
  for (let email of assets) {
    newData.push({
      id: email.email_id,
      campaignId: email.campaign_id,
      campaignName: email.campaign_name,
      isHybrid: email.digest_email ? true : false,
      isCustom: email.adhoc_email ? true : false,
      isAIEmail: email.ai_email ? true : false,
      name: email.email_name,
      dateTime: email.last_sent,
      sentBy: email.sent_by,
      aiType: email.personality,
      aiColor: email.personality_color,
      aiName: email.personality_name,
      subject: email.email_subject,
    });
  }
  return newData;
};

export const serializeAnalyticsCampaigns = (campaigns: any[]) => {
  let newData: ICampaignDropdownItem[] = [];
  for (let campaign of campaigns) {
    newData.push({
      id: campaign.campaign_id,
      isHybrid: campaign.digest_email,
      isCustom: campaign.adhoc_email,
      name: campaign.campaign_name,
      dateTime: campaign.last_update,
    });
  }
  return newData;
};

export const serializeAnalyticsWorkflow = (workflows: any[]) => {
  let newData: IWorkflowDropdownItem[] = [];
  for (let workflow of workflows) {
    newData.push({
      id: workflow.id,
      name: workflow.name,
      dateTime: workflow.created_on,
      sentBy: workflow.sender_email,
      status: workflow.status,
      emails: workflow.workflow_emails,
    });
  }
  return newData;
};

export const getCurrentTime = () => {
  const dateTimeString = new Date().toISOString().split('T');
  dateTimeString[1] = dateTimeString[1].split('.')[0];
  return dateTimeString[0] + ' ' + dateTimeString[1];
};

export const isDateOfToday = (utcEpoch: number) => {
  if (!!utcEpoch) {
    let dateTimeString: any = new Date(0);
    dateTimeString.setUTCSeconds(utcEpoch);
    dateTimeString = dateTimeString.toISOString().split('T');
    const date1 = new Date(dateTimeString[0]);
    const date2 = new Date(getCurrentTime().split(' ')[0]);
    return date1.getTime() == date2.getTime();
  }
  return false;
};

export const setSortDirection = (id: string, sortDirection: string) => {
  switch (sortDirection) {
    case 'none':
      return 'DESC';
    case 'ASC':
      return 'none';
    case 'DESC':
      return 'ASC';
    default:
      return 'none';
  }
};
export const resetAllContactProps = (delivered?: boolean, bounced?: boolean, unsubscribed?: boolean) => {
  if (!delivered) store.dispatch({ type: CONTACT_ANALYTICS.DELIVERED_RESET });
  if (!bounced) store.dispatch({ type: CONTACT_ANALYTICS.BOUNCED_RESET });
  if (!unsubscribed) store.dispatch({ type: CONTACT_ANALYTICS.UNSUBSCRIBED_RESET });
};

export const getAllAnalyticsTab = (page?: string, searchedText?: string, tab?: string) => {
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
    payload: true,
  });

  let analyticsDashboard = store.getState().analyticsDashboard;
  let analyticsGraph = store.getState().analyticsGraph;
  let { contactsByFilter, bounceFilter } = store.getState().contactAnalytics;
  let { appliedCampaignIds, appliedAssetsIds, appliedExcludeCampaignIds, appliedExcludeAssetsIds, appliedWorkflowsIds, isWorkflow } =
    analyticsDashboard;
  let { isAllCampaigns, isShareProfile, isDailyIQ, isWeeklyAccountInsights } = analyticsDashboard.appliedCampaignsFilters;

  let { appliedStartDate, appliedEndDate } = analyticsGraph;

  let _params: any = {
    allCampaigns: isAllCampaigns,
    campaignIds: appliedCampaignIds,
    emailIds: appliedAssetsIds,
    startDate: appliedStartDate,
    endDate: appliedEndDate,
  };

  if (isAllCampaigns) {
    _params['excludeCampaignsIds'] = appliedExcludeCampaignIds;
    _params['excludeAssetsIds'] = appliedExcludeAssetsIds;
  }

  if (searchedText) _params['searchWord'] = searchedText;
  if (isShareProfile) {
    _params['emailIds'] = [ANALYTICS_CAMPAIGNS_ID.SHARED_PROFILE];
    _params['campaignIds'] = [ANALYTICS_CAMPAIGNS_ID.SHARED_PROFILE];
  } else if (isDailyIQ) {
    _params['emailIds'] = [ANALYTICS_CAMPAIGNS_ID.DAILY_IQ];
    _params['campaignIds'] = [ANALYTICS_CAMPAIGNS_ID.DAILY_IQ];
  } else if (isWeeklyAccountInsights) {
    _params['emailIds'] = [ANALYTICS_CAMPAIGNS_ID.WEEKLY_ACCOUNTS_INSIGHTS];
    _params['campaignIds'] = [ANALYTICS_CAMPAIGNS_ID.WEEKLY_ACCOUNTS_INSIGHTS];
  }
  if (isWorkflow && appliedWorkflowsIds?.length > 0) {
    _params['workflowIds'] = appliedWorkflowsIds;
  }
  //Dashboard
  _params['exportAnalytics'] = true;
  if (page === TAB_ANALYTICS.ACCOUNTS) {
    getPaginatedAccountsData(_params);
  } else if (page === TAB_ANALYTICS.CONTACTS) {
    if (getQueryAccountId()) _params['account_id'] = getQueryAccountId();
    if (contactsByFilter) _params['contactsByFilter'] = contactsByFilter;
    if (bounceFilter) _params['bounceFilter'] = bounceFilter;
    getDeliveredContactsList(_params);
  } else if (page === TAB_ANALYTICS.CONTENT) {
    getPaginatedContentData(_params);
  } else if (page === 'accounts_dashboard') {
    _params['export_from_accounts'] = true;
    _params['accountId'] = getQueryAccountId();
    _params['onlyContacts'] = 1;
    getAccountsDashboard(_params);
  } else if (page === 'accounts_content') {
    _params['accountId'] = getQueryAccountId();
    _params['export_from_accounts'] = true;
    getContentEngagementList(_params);
  } else if (page === 'insights' && tab === 'clickTrends') {
    getClickTrends(_params);
  } else if (page === 'insights') {
    getEmailTrends(_params);
  } else {
    getAnalyticsCardData(_params);
  }
};

export const resetAllTabsFilter = (value: boolean) => {
  store.dispatch({ type: ANALYTICS_CARD_DATA.FILTER_RESET, payload: value });
  store.dispatch({ type: ANALYTICS_ACCOUNTS_DATA.FILTER_RESET, payload: value });
  store.dispatch({ type: CONTENT_ANALYTICS.FILTER_RESET, payload: value });
  store.dispatch({ type: CONTACT_ANALYTICS.FILTER_RESET, payload: value });
};
export const exitAnalyticsWrapper = () => {
  store.dispatch({ type: ANALYTICS_CARD_DATA.RESET, payload: true });
  store.dispatch({ type: ANALYTICS_ACCOUNTS_DATA.RESET, payload: true });
  store.dispatch({ type: CONTENT_ANALYTICS.RESET, payload: true });
  store.dispatch({ type: CONTACT_ANALYTICS.DELIVERED_RESET, payload: true });
  store.dispatch({ type: CONTACT_ANALYTICS.BOUNCED_RESET, payload: true });
  store.dispatch({ type: CONTACT_ANALYTICS.UNSUBSCRIBED_RESET, payload: true });
};
export const resetContactSearch = () => {
  store.dispatch({ type: CONTACT_ANALYTICS.SEARCH_RESET, payload: true });
};
export const resetAccountSearch = () => {
  store.dispatch({ type: ANALYTICS_ACCOUNTS_DATA.SEARCH_RESET, payload: true });
};
export const resetContentSearch = () => {
  store.dispatch({ type: CONTENT_ANALYTICS.SEARCH_RESET, payload: true });
};

export const getConstantCampaignEmailId = ({ isShareProfile, isDailyIQ, isWeeklyAccountInsights }: any) => {
  return isShareProfile
    ? ANALYTICS_CAMPAIGNS_ID.SHARED_PROFILE
    : isDailyIQ
    ? ANALYTICS_CAMPAIGNS_ID.DAILY_IQ
    : isWeeklyAccountInsights
    ? ANALYTICS_CAMPAIGNS_ID.WEEKLY_ACCOUNTS_INSIGHTS
    : 0;
};
